import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { getRGBAColor } from '../../utils/settings';
import { Info } from '@mui/icons-material';

function StatusStickerComponent({
  color = '#ffffff',
  containerStyle = {},
  textStyle = {},
  title = '',
  remark = '',
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        direction: 'row',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={[
          {
            borderRadius: '10px',
            textAlign: 'center',
            backgroundColor: getRGBAColor(color),
          },
          containerStyle,
        ]}
      >
        <Typography
          sx={[
            {
              color: color,
              // color: '#01522B'
            },
            textStyle,
          ]}
        >
          {title}
        </Typography>
      </Box>

      {remark && (
        <Tooltip
          title={remark}
          placement='top'
        >
          <IconButton color='primary'>
            <Info />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}

export default StatusStickerComponent;
